import { render, staticRenderFns } from "./printpo.vue?vue&type=template&id=5de71f09&scoped=true&"
import script from "./printpo.vue?vue&type=script&lang=js&"
export * from "./printpo.vue?vue&type=script&lang=js&"
import style0 from "./printpo.vue?vue&type=style&index=0&id=5de71f09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de71f09",
  null
  
)

export default component.exports